import React, {FC, memo, useState} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import {SideBarIcons} from './parts/SideBarIcons';
import {typeComponents} from './constants';
import {IPersonalizeCmpProps, PersonalizeCmp} from './parts/Personalize/Personalize';
import {ImageCmp} from './parts/Image/Image';
import {HyperlinkCmp} from './parts/Hyperlink/Hyperlink';
import styles from '../styles.module.scss';
import cx from 'classnames';
import {TIconType} from './types';
import {ETargetAutoFill} from '../RichText/types';
import {createDataTestId} from '../../../../utils/dataTestId';

interface ISideBarProps {
    targetAutoFill: React.MutableRefObject<ETargetAutoFill>;
    messageCursorLastPosition: React.MutableRefObject<number>;
    subjectInputRef: React.MutableRefObject<HTMLInputElement>;
}

const iconObjectComponents = {
    personalize: (props: IPersonalizeCmpProps) => <PersonalizeCmp {...props} />,
    image: () => <ImageCmp />,
    hyperlink: () => <HyperlinkCmp />
};

export const SideBar: FC<ISideBarProps> = memo(props => {
    const [activeComponent, setActiveComponent] = useState<TIconType>(typeComponents.PERSONALIZE);

    return (
        <Flex componentClasses={styles.sideBarContainer}>
            <div className={cx(styles.fullHeight)}>
                <SideBarIcons {...{activeComponent, setActiveComponent}} />
            </div>
            <Flex
                componentClasses={styles.box}
                {...createDataTestId(`email-side-bar-box-container`, true)}
            >
                <Flex
                    direction="column"
                    componentClasses={styles.containerFullHeight}
                    alignItems="flex-start"
                >
                    {iconObjectComponents[activeComponent]?.(
                        activeComponent === typeComponents.PERSONALIZE ? props : null
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
});
